<template>
  <a-tabs default-active-key="1">
  <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="car"/>
            Licencia(s) de Conducción
          </span>
    <a-col :span="24">
      <a-card>
        <biodata-licencias-conduccion :persona="persona"></biodata-licencias-conduccion>
      </a-card>
    </a-col>
  </a-tab-pane>
  </a-tabs>
</template>

<script>
    export default {
      props: ['persona']
    }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataConduccion.vue